import { useEffect } from 'react'
import { useDrag } from 'react-dnd'
import { Shipment } from '../../types/coreEntitiesTypes'
import InstantGridGroupRow, { InstantGridGroupRowProps } from './InstantGridGroupRow'
import { beginDragRow, endDragRow, ORDER_DND_TYPE } from './instantGridDnd'

function InstantGridDraggableGroupRow<T>(props: InstantGridGroupRowProps<T>) {
  const { dragPreview, group, id, index, onDragEnd, ...restProps } = props

  const [, connectDragSource, connectDragPreview] = useDrag(
    () => ({
      type: ORDER_DND_TYPE,
      item: () => beginDragRow({ id, index }),
      end: (_item, monitor) =>
        endDragRow({ id, index, onDragEnd }, group as unknown as Shipment, monitor.getDropResult())
    }),
    [id, index, group, onDragEnd]
  )

  useEffect(() => {
    if (dragPreview && connectDragPreview) {
      const img = new Image()
      img.src = dragPreview
      img.onload = () => connectDragPreview(img)
    }
  }, [dragPreview, connectDragPreview])

  const setRef = (el: any) => connectDragSource(el)

  return (
    <InstantGridGroupRow
      setRef={setRef}
      isDragEnabled={true}
      group={group}
      id={id}
      index={index}
      onDragEnd={onDragEnd}
      {...restProps}
    />
  )
}

export default InstantGridDraggableGroupRow
